import Vue from 'vue'
import Router from 'vue-router'
import { constantRouterMap } from '@/common/config/router.config'

/*解决跳转相同路径报错问题*/
// hack router push callback
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  	if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  	return originalPush.call(this, location).catch(err => err)
}
/*end*/

Vue.use(Router)

export default new Router({
	//mode: 'history',   //消除hash模式下的#,但需要服务器配置
  	routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js